// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13mgA","footer":"styles_footer__3BVNH","passCodeTooltip":"styles_passCodeTooltip__1kPQr"};